export default __webpack_public_path__ + "static/media/arrow-right-circle.e2e9c73b.svg";